import {
  post_request,
  get_request_export
} from '../axiosFun'

//查询车辆监管列表
export const get_detail_list = (params) => {
  params = {
    row: {
      vin: params,
    }
  }
  return post_request("/web/carMonitor/detail", params)
}
//查询车辆监管列表
export const get_history_list = (params) => {
  params = {
    row: {
      vin: params,
      in_date: "",
      out_date:"",
      type:"",
      module:"",
      page_no:1,
      page_size:10
    }
  }
  return post_request("/web/carMonitor/history", params)
}
//查询车辆定位
export const get_car_position = (params) => {
  params = {
    row: {
      vin:params
    }
  }
  return post_request("/web/carMonitor/position", params)
}



// WEBPACK FOOTER //
// ./src/api/car_supervise/Regulatory_details.js